import { Component, OnInit } from '@angular/core';
import {SectionBase} from '../../../components/section/section-base';
import {PaymentMethodsService} from '../../../../core/services/impl/section-services/method-payments/payment-methods.service';
import {NextPaymentMethodSectionConfig} from './next-payment-method-section-config';
import {ControlChange} from '../../../../core/models/control-change.model';
import {PaymentMethodSectionFieldKey} from '../../../../core/consts/payment-method-section-field-key.enum';
import {PaymentMethod} from '../../../../core/consts/payment-method.enum';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-next-payment-method-section',
  templateUrl: './next-payment-method-section.component.html',
  styleUrls: []
})
export class NextPaymentMethodSectionComponent extends SectionBase implements OnInit {

  SectionFieldKey = PaymentMethodSectionFieldKey;

  private config: NextPaymentMethodSectionConfig = new NextPaymentMethodSectionConfig(this.paymentMethodsService, this.ts);

  get contractInfo(): string {
    if (this.paymentMethodsService.methodPayment === PaymentMethod.STANDARD_TRANSFER) {
      return 'METHOD_PAYMENT_SECTION.buyContractInfo';
    } else {
      return 'METHOD_PAYMENT_SECTION.payContractInfo';
    }
  }

  constructor(public paymentMethodsService: PaymentMethodsService,
              private ts: TranslateService) {
    super();
    this.paymentMethodsService.init();
  }

  ngOnInit() {
    this.createConfig();
    this.initBean();
    this.buildForm();

    this.initControlsChanges();
  }

  createConfig(): void {
    this.formConfig = this.config.createConfig();
  }

  initBean(): void {
    this.bean = {
      [PaymentMethodSectionFieldKey.PAYMENT_METHOD]: this.paymentMethodsService.methodPayment
    };
  }

  initControlsChanges(): void {
    let controlsChanges: ControlChange[] = [{
      controlName: PaymentMethodSectionFieldKey.PAYMENT_METHOD,
      behaviour: value => this.paymentMethodsService.changeMethodPayment(value)
    }];
    this.handleControlsState(...controlsChanges);
  }

  getPaymentMethodTileContentCssClass(method: PaymentMethod): string {
    return `payment-method-tile-content--${method.replace(/_/g, '-').toLowerCase()}`;
  }

}
